module.exports = __webpack_public_path__ + "img/1F63E.3078bf17.svg";